import React, { useEffect, useState } from "react";
import "../styles/productlist.css";
import ProductCard from "./common/ProductCard";
import axios from "axios";
import Constant from "../helper/Constant";
import { useLocation, useNavigate } from "react-router-dom";
// import miniatureImg from "../assets/images/miniature.png";

// const CUSTOM_CATEGORY_ID = "custom-miniature";
//
// const isCustomMiniatureCategory = (cat) =>
//   cat?._id === CUSTOM_CATEGORY_ID ||
//   cat?.title?.toLowerCase() === "custom miniature";
//
// const buildDummyCustomProduct = () => ({
//   _id: "custom-miniature-dummy",
//   link: "/custom",
//   image: miniatureImg,
//   name: "Custom Miniature",
//   price: 4400,
//   offer_price: 4400,
//   category: {
//     _id: CUSTOM_CATEGORY_ID,
//     title: "Custom Miniature",
//   },
// });

export default function ProductListing() {
  const navigate = useNavigate();
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [priceRange, setPriceRange] = useState({});
  const [page, setPage] = useState(1);
  const limit = 20;
  const filterCategories = categories;

  // Read URL
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const catIdFromURL = queryParams.get("catId");
  const searchFromURL = queryParams.get("search") || "";
  const minPriceFromURL = queryParams.get("minPrice");
  const maxPriceFromURL = queryParams.get("maxPrice");
  const sortFromURL = queryParams.get("sort") || "";

  /* CATEGORY FETCH */
  const getAllCategories = async () => {
    try {
      const res = await axios.get(
        Constant.getUrls.getAllCategories + "?page=1&limit=50"
      );
      const docs = res.data.data.docs || [];
      // const hasCustomCategory = docs.some(
      //   (cat) => cat.title?.toLowerCase() === "custom miniature",
      // );
      //
      // setCategories(
      //   hasCustomCategory
      //     ? docs
      //     : [...docs, { _id: CUSTOM_CATEGORY_ID, title: "Custom Miniature" }],
      // );
      // setCategories(docs);
      setCategories(
        (docs || []).filter(
          (item) =>
            item.status?.toLowerCase() !== "inactive"
        )
      );
    } catch (err) {
      console.log(err);
    }
  };

  /* PRODUCT FETCH */
  const getAllProducts = async (filters = {}) => {
    try {
      let url = `${Constant.postUrls.getAllProductsList}?page=${page}&limit=${limit}`;

      if (filters.categories?.length) {
        url += `&catId=${filters.categories.join(",")}`;
      }

      if (filters.minPrice) url += `&minPrice=${filters.minPrice}`;
      if (filters.maxPrice) url += `&maxPrice=${filters.maxPrice}`;
      if (filters.search) url += `&search=${encodeURIComponent(filters.search)}`;
      if (filters.sort) url += `&sort=${filters.sort}`;

      const res = await axios.get(url);
      const apiProducts = res.data.data.docs || [];
      // const customCategory = categories.find(
      //   (cat) => isCustomMiniatureCategory(cat),
      // );
      // const onlyCustomCategorySelected =
      //   filters.categories?.length === 1 &&
      //   (filters.categories[0] === CUSTOM_CATEGORY_ID ||
      //     customCategory?._id === filters.categories[0]);
      //
      // setProducts(
      //   onlyCustomCategorySelected
      //     ? [buildDummyCustomProduct()]
      //     : apiProducts,
      // );
      setProducts(apiProducts);
    } catch (err) {
      console.log(err);
    }
  };

  /* CATEGORY SELECT */
  const handleCategoryChange = (id) => {
    let updated = [...selectedCategories];

    if (updated.includes(id)) {
      updated = updated.filter((c) => c !== id);
    } else {
      updated.push(id);
    }

    setSelectedCategories(updated);
  };

  /* PRICE SELECT */
  const handlePriceChange = (range) => {
    if (range === "under500") setPriceRange({ minPrice: 0, maxPrice: 500 });

    if (range === "500to1000")
      setPriceRange({ minPrice: 500, maxPrice: 1000 });

    if (range === "1000plus") setPriceRange({ minPrice: 1000 });
  };

  /* APPLY FILTER */
  const applyFilters = () => {
    const params = new URLSearchParams();

    if (selectedCategories.length) {
      params.set("catId", selectedCategories.join(","));
    }

    if (searchFromURL) {
      params.set("search", searchFromURL);
    }

    if (priceRange.minPrice) {
      params.set("minPrice", priceRange.minPrice);
    }

    if (priceRange.maxPrice) {
      params.set("maxPrice", priceRange.maxPrice);
    }

    if (sortFromURL) {
      params.set("sort", sortFromURL);
    }

    navigate(`/products?${params.toString()}`);
    setShowMobileFilters(false);
  };

  /* INITIAL LOAD */
  useEffect(() => {
    getAllCategories();
  }, []);

  /* Listen to URL change */
  useEffect(() => {
    const categoriesFromUrl = catIdFromURL ? catIdFromURL.split(",").filter(Boolean) : [];
    const inferredCategories =
      !categoriesFromUrl.length && searchFromURL
        ? categories
            .filter((cat) => {
              const title = String(cat?.title || "").toLowerCase();
              const search = searchFromURL.toLowerCase();
              return title.includes(search) || search.includes(title);
            })
            .map((cat) => cat._id)
        : [];
    const resolvedCategories = categoriesFromUrl.length
      ? categoriesFromUrl
      : inferredCategories;
    const nextPriceRange = {};

    if (minPriceFromURL) {
      nextPriceRange.minPrice = Number(minPriceFromURL);
    }

    if (maxPriceFromURL) {
      nextPriceRange.maxPrice = Number(maxPriceFromURL);
    }

    setSelectedCategories(resolvedCategories);
    setPriceRange(nextPriceRange);

    getAllProducts({
      categories: resolvedCategories,
      search: searchFromURL,
      sort: sortFromURL,
      ...nextPriceRange,
    });
  }, [catIdFromURL, categories, searchFromURL, minPriceFromURL, maxPriceFromURL, sortFromURL]);

  return (
    <div className="plp-container">
      {/* DESKTOP FILTER */}
      <aside className="plp-filters">
        <h3>Category</h3>

        <div className="filter-block">
          {filterCategories.map((cat) => (
            <label key={cat._id}>
              <input
                type="checkbox"
                checked={selectedCategories.includes(cat._id)}
                onChange={() => handleCategoryChange(cat._id)}
              />
              {cat.title}
            </label>
          ))}
        </div>

        <div className="filter-block">
          <label>
            <input
              type="radio"
              name="price"
              onChange={() => handlePriceChange("under500")}
            />
            Under ₹500
          </label>

          <label>
            <input
              type="radio"
              name="price"
              onChange={() => handlePriceChange("500to1000")}
            />
            ₹500–₹1000
          </label>

          <label>
            <input
              type="radio"
              name="price"
              onChange={() => handlePriceChange("1000plus")}
            />
            ₹1000+
          </label>
        </div>

        <button className="apply-filter-btn" onClick={applyFilters}>
          Apply Filters
        </button>
      </aside>

      {/* PRODUCTS */}
      <section className="plp-products">
        <div className="plp-header">
          <div>
            <h2>Products</h2>
            {searchFromURL ? <p className="plp-search-summary">Results for "{searchFromURL}"</p> : null}
          </div>

          <select
            className="plp-sort"
            value={sortFromURL}
            onChange={(e) => {
              const params = new URLSearchParams(location.search);
              if (e.target.value) {
                params.set("sort", e.target.value);
              } else {
                params.delete("sort");
              }
              navigate(`/products?${params.toString()}`);
            }}
          >
            <option value="">Sort by</option>
            <option value="sortA">Oldest</option>
            <option value="sortD">Newest</option>
          </select>
        </div>

        <button
          className="mobile-filter-btn"
          onClick={() => setShowMobileFilters(true)}
        >
          Filter
        </button>

        {/* MOBILE FILTER */}
        <div
          className={`mobile-filter-overlay ${
            showMobileFilters ? "show" : ""
          }`}
        >
          <div className="mobile-filter-panel">
            <div className="mobile-filter-header">
              <h3>Category</h3>
              <button onClick={() => setShowMobileFilters(false)}>✕</button>
            </div>

            <div className="mobile-filter-content">
              <div className="filter-block">
                {filterCategories.map((cat) => (
                  <label key={cat._id}>
                    <input
                      type="checkbox"
                      checked={selectedCategories.includes(cat._id)}
                      onChange={() => handleCategoryChange(cat._id)}
                    />
                    {cat.title}
                  </label>
                ))}
              </div>

              <div className="filter-block">
                <label>
                  <input
                    type="radio"
                    name="price"
                    onChange={() => handlePriceChange("under500")}
                  />
                  Under ₹500
                </label>

                <label>
                  <input
                    type="radio"
                    name="price"
                    onChange={() => handlePriceChange("500to1000")}
                  />
                  ₹500–₹1000
                </label>

                <label>
                  <input
                    type="radio"
                    name="price"
                    onChange={() => handlePriceChange("1000plus")}
                  />
                  ₹1000+
                </label>
              </div>
            </div>

            <button className="apply-filter-btn" onClick={applyFilters}>
              Apply Filters
            </button>
          </div>
        </div>

        {/* PRODUCT GRID */}
        <div className="plp-grid">
          {products.map((product) => (
            <ProductCard key={product._id} product={product} />
          ))}
        </div>
      </section>
    </div>
  );
}
